import * as actionTypes from '../actionTypes';

export const getFeatures = function () {
  return { type: actionTypes.GET_FEATURES };
};
